import { createFileRoute } from '@tanstack/react-router';
import { head } from '@pages/CompareDbosVsTemporalPage.head';
import { CompareDbosVsTemporalPage } from '@pages/CompareDbosVsTemporalPage';

export const Route = createFileRoute('/compare/dbos-vs-temporal')({
  component: CompareDbosVsTemporalPage,
  head: () => head,
});
